import { SessionResponse } from "../contracts/SessionResponse";
import { InviteeResponse } from "../contracts/InviteeResponse";
import { Session } from "../models/Session";
import { Invitee } from "../models/Invitee";
import { PaymentActivityType } from "../models/PaymentActivityType";
import { BookingStatus } from "../models/BookingStatus";
import { RecurrenceType } from "../models/RecurrenceType";
import { convertUTCToTimezone } from "../../utils/timezoneUtils";

export class SessionResponseMapper {
  /**
   * Converts a SessionResponse to a Session model
   * @param resp - The session response from the API
   * @returns The converted Session model
   */
  toSession = (resp: SessionResponse): Session => {
    const isoString = resp.dateStart.endsWith("Z")
      ? resp.dateStart
      : resp.dateStart + "Z";
    const dateStart = convertUTCToTimezone(
      isoString,
      resp.timeZone
    ).toISOString();
    return {
      id: resp.id,
      paymentActivityType: resp.paymentActivityType as PaymentActivityType,
      title: resp.title,
      description: resp.description,
      dateStart: dateStart,
      timeLocal: resp.timeLocal,
      timeZone: resp.timeZone,
      duration: resp.duration,
      isAllDay: resp.isAllDay,
      status: resp.status as BookingStatus,
      recurrenceType: resp.recurrenceType as RecurrenceType,
      recurrenceDays: resp.recurrenceDays,
      recurrenceDaysNumber: resp.recurrenceDaysNumber,
      recurrenceDateEnd: resp.recurrenceDateEnd
        ? (new Date(resp.recurrenceDateEnd) as Date)
        : undefined,
      finishAfterOccurrences: resp.finishAfterOccurrences,
      remindBefore: resp.remindBefore,
      invitees: resp.invitees.map(this.toInvitee),
      dateCreated: resp.dateCreated,
      dateModified: resp.dateModified,
    };
  };

  /**
   * Converts multiple SessionResponse objects to Session models
   * @param responses - Array of session responses from the API
   * @returns Array of converted Session models
   */
  toSessions = (responses: SessionResponse[]): Session[] => {
    return responses.map(this.toSession);
  };

  /**
   * Converts an InviteeResponse to an Invitee model
   * @param resp - The invitee response from the API
   * @returns The converted Invitee model
   */
  toInvitee = (resp: InviteeResponse): Invitee => {
    return {
      id: resp.id,
      invitedUserId: resp.invitedUserId,
      bookingId: resp.bookingId,
      type: resp.type,
      dateCreated: resp.dateCreated,
      dateModified: resp.dateModified,
    };
  };
}
